const ENTRADAS_TRASLADO = (state, entradas_traslado) => {
    state.entradas_traslado = entradas_traslado;
};

export default {
    ENTRADAS_TRASLADO,
};